import { render, staticRenderFns } from "./DictationItemMain.vue?vue&type=template&id=b774758e&scoped=true"
import script from "./DictationItemMain.vue?vue&type=script&lang=js"
export * from "./DictationItemMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b774758e",
  null
  
)

export default component.exports